import request from '@/utils/request'
export const getBanner = () => { return request('/api/index/banner') }
export const isBindStaff = () => { return request('/api/index/isbindstaff') }
export const myupload = (data) => {
  return request.post('/api/common/uploadnew', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
